import { useEffect, useState } from 'react';
import type { AnyActorRef } from 'xstate';

export function useFieldActorSnapshot(actor: AnyActorRef) {
  const [snapshot, setSnapshot] = useState(() => actor.getSnapshot());

  useEffect(() => {
    const sub = actor.subscribe(setSnapshot);
    return () => sub.unsubscribe();
  }, [actor]);

  return snapshot;
}
